import Header from '@/components/header'
import RootProviders from '@/providers/root-providers'
import { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet, redirect, useRouterState } from '@tanstack/react-router'
import type { Api } from '@/api/api'
import '../index.css'
import { customerSubject, getAuth, termsAccepted } from '@/utils/auth'
import { tenant } from '@/tenants/tenant'
import { isLoginRequired } from '@/utils/tester-mode'
import { ONBOARDING_PREFIX, resolveRootRedirect } from '@/utils/route-guards'
import { GlobalDrawers } from '@/components/global-drawers'

interface RouterContextType {
	queryClient: QueryClient
	api: Api
}

export const Route = createRootRouteWithContext<RouterContextType>()({
	beforeLoad: ({ location }) => {
		const result = resolveRootRedirect({
			pathname: location.pathname,
			onboarding: tenant.features.onboarding,
			customer: customerSubject.value,
			termsAcceptedLocally: termsAccepted.value,
			loginRequired: isLoginRequired(),
			isLoggedIn: getAuth().isLoggedIn
		})

		if (result) {
			if (result.to === '/') {
				throw redirect({ to: '/' })
			}
			throw redirect({ to: result.to, search: { redirect: result.redirect } })
		}
	},
	component: RootLayout
})

function RootLayout() {
	const routerState = useRouterState()
	const isOnboarding = routerState.location.pathname.startsWith(ONBOARDING_PREFIX)

	return (
		<RootProviders>
			{!isOnboarding && <Header />}
			<Outlet />
			<GlobalDrawers />
		</RootProviders>
	)
}
